import { getAssetDetailsLabel, type SampleData } from '../Service.types';
import { FieldRow } from './field-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { formatPercentage } from '../../utils';
import { useQuery } from '@tanstack/react-query';
import { useRmxServiceApi } from '../api';

export function SampleDetails({ sample }: { sample: SampleData; onChange?: (value: any) => void }) {
  const issuesString = sample?.issues?.trim().toUpperCase() ?? undefined;
  const issuesArray = issuesString?.split('; ');
  const api = useRmxServiceApi();

  const getAssetDetails = useQuery({
      queryKey: ['asset', sample.assetId],
      queryFn: async () => {
        return await api.getCustomerAndSiteAssets({ assetId: sample.assetId });
      }
    }),
    { data: assetData } = getAssetDetails;
  const fieldNames = [
    'customerName',
    'assetId',
    'sampleHours',
    'bearingMetals',
    'coolerMetals',
    'oxidation',
    'filter',
    'ph',
    'tan',
    'viscosityDeviations',
    'viscosity',
    'sampleDate',
    'issues'
  ] as const satisfies (keyof SampleData & string)[];

  return (
    <>
      {fieldNames.map((name, index) => {
        const isIssue = issuesArray?.includes(name.trim().toUpperCase());

        if (name === 'viscosityDeviations') {
          const concernVis = issuesArray?.includes('VISCOSITY DEVIATION');
          const viscosityDeviationsPercent = formatPercentage(sample.viscosityDeviations, 3);
          return (
            <FieldRow<SampleData>
              key={index}
              name={name}
              header='Viscosity Deviations'
              value={viscosityDeviationsPercent}
              extraContent={<td>{concernVis && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
            />
          );
        }
        if (name === 'bearingMetals') {
          const concernBear = issuesArray?.includes('BEARING');
          return (
            <FieldRow<SampleData>
              key={index}
              name={name}
              header='Bearing Metals'
              value={sample[name]}
              extraContent={<td>{concernBear && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
            />
          );
        }

        if (name === 'coolerMetals') {
          const concernCool = issuesArray?.includes('COOLER');
          return (
            <FieldRow<SampleData>
              key={index}
              name={name}
              header='Cooler Metals'
              value={sample[name]}
              extraContent={<td>{concernCool && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
            />
          );
        }

        if (name === 'issues') {
          return (
            <FieldRow<SampleData>
              key={index}
              name={name}
              header='Concerns'
              value={sample[name]}
              extraContent={<td>{isIssue && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
            />
          );
        }
        if (name === 'assetId') {
          return (
            <FieldRow<SampleData>
              key={index}
              name={name}
              header='Asset'
              value={assetData?.length ? getAssetDetailsLabel(assetData[0]) : ''}
              extraContent={<td>{isIssue && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
            />
          );
        }

        return (
          <FieldRow<SampleData>
            key={index}
            name={name}
            header={name.charAt(0).toUpperCase() + name.slice(1)}
            value={sample[name]}
            extraContent={<td>{isIssue && <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'red', marginLeft: '4px' }} />}</td>}
          />
        );
      })}
    </>
  );
}
